<form novalidate (ngSubmit)="submit()" [formGroup]="form">
  <ion-list style="padding: 0 0 1px 0;">
    <ion-item lines="none" style="--min-height:30px">

      <ion-label style="margin: 0px;">
        <p class="hidden-sm-up" style="font-size: .8rem;">

          Your Credit Information
        </p>
      </ion-label>
      <div class="cc-images" style="margin: 1px 0 0 0;">
        <div style="display: inline-block;"><img src="assets/imgs/checkout/visa.png"></div>
        <div style="display: inline-block;"><img src="assets/imgs/checkout/mc.png"></div>
        <div style="display: inline-block;"><img src="assets/imgs/checkout/amex.png"></div>
        <div style="display: inline-block;"><img src="assets/imgs/checkout/discover.png"></div>
      </div>
    </ion-item>





    <ion-grid class="no-padding" style="padding: 0 5px">
      <ion-row>
        <ion-col style="padding: 0;">
          <div class="custom-form-group">
            <input autocomplete="new-password" formControlName="fullName" (ionChange)="submit()" id="fullname" class="form-control" type="text"  placeholder="" required>
            <label for="fullName">{{ 'CreditCard.FullName' | translate }}<span style="color:red;">*</span></label>
            @if (formFieldValidator('fullName', 'required')) {
              <span style="padding-bottom: 2px;" class="form-errors"
              >{{ 'CreditCard.FormErrors.CardHolderNameRequired' | translate}}</span>
            }
          </div>
          <!-- <ion-item class="boxexpiry">
          <ion-label position="floating">
            {{ 'CreditCard.FullName' | translate }}
            <span *ngIf="formErrors.has('fullName')" color="danger"><br />{{formErrors.get('fullName')}}</span>
          </ion-label>
          <ion-input autocomplete="new-password" formControlName="fullName" type="text" (ionChange)="submit()"></ion-input>
          <span class="form-errors"
          *ngIf="formFieldValidator('fullName', 'required')">{{ 'CreditCard.FormErrors.CardHolderNameRequired' | translate}}</span>
        </ion-item> -->
      </ion-col>
      <ion-col style="padding: 0;">
        <div class="custom-form-group">
          <input autocomplete="new-password" formControlName="number" (ionChange)="submit()" id="number" class="form-control" type="number"  placeholder="" required>
          <label for="number">{{ 'CreditCard.CardNumber' | translate }}@if (formErrors.has('number')) {
            <span color="danger"><br />{{formErrors.get('number')}}</span>
          }</label>
          @if (formFieldValidator('number', 'required')) {
            <span style="padding-bottom: 2px;" class="form-errors"
            >{{ 'CreditCard.FormErrors.CardNumberRequired' | translate}}</span>
          }
        </div>
        <!-- <ion-item class="box">
        <ion-label position="floating">
          {{ 'CreditCard.CardNumber' | translate }}
          <span *ngIf="formErrors.has('number')" color="danger"><br />{{formErrors.get('number')}}</span>
        </ion-label>
        <ion-input autocomplete="new-password" formControlName="number" type="number" (ionChange)="submit()"></ion-input>
        <span class="form-errors"
        *ngIf="formFieldValidator('number', 'required')">{{ 'CreditCard.FormErrors.CardNumberRequired' | translate}}</span>
      </ion-item> -->
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="padding: 0;">
      <div class="custom-form-group">
        <div style="display: inline-flex;" class="exp-wrapper">
          <input class="exp" autocomplete="new-password" formControlName="expiryMonth" (ionChange)="submit()" id="expiry" class="form-control" type="number"  placeholder="MM" required style="border-right: 0;border-radius: 2px 0px 0px 2px;-webkit-appearance: none;-moz-appearance: textfield;">
          <label for="expiry" class="expLabel">{{ 'CreditCard.Expiration' | translate }}@if (formErrors.has('number')) {
            <span color="danger"><br />{{formErrors.get('number')}}</span>
          }</label>
          <!-- <span>/</span> -->
          <input class="exp" autocomplete="new-password" formControlName="expiryYear" (ionChange)="submit()" id="" class="form-control" type="number"  placeholder="YYYY" required style="border-left: 0;border-radius: 0px 2px 2px 0px;">
        </div>
        @if (formFieldValidator('expiryMonth', 'min') || formFieldValidator('expiryMonth', 'max') || formFieldValidator('expiryYear', 'min') || formFieldValidator('expiryYear', 'max') || formFieldValidator('expiryMonth', 'required') || formFieldValidator('expiryYear', 'required')) {
          <span style="padding-bottom: 2px;" class="form-errors"
          >{{ 'CreditCard.FormErrors.ExpirationInvalid' | translate}}</span>
        }
      </div>
      <!-- <ion-item class="box">
      <ion-label position="floating">
        {{ 'CreditCard.Expiration' | translate }}
        <span *ngIf="formErrors.has('expiry')" color="danger"><br />{{formErrors.get('expiry')}}</span>
      </ion-label>
      <div style="display:flex;">
        <ion-input autocomplete="new-password" item-start  placeholder="MM" (ionChange)="submitMonth()" formControlName="expiryMonth" type="number" ></ion-input>
        <p style="padding-right:20px;">/</p>
        <ion-input  autocomplete="new-password" placeholder="YYYY" (ionChange)="submitYear()"  formControlName="expiryYear" type="number"></ion-input>
      </div>
      <span class="form-errors"
      *ngIf="formFieldValidator('expiryMonth', 'required')">{{ 'CreditCard.FormErrors.ExpirationMonthRequired' | translate}}</span>
      <span class="form-errors"
      *ngIf="formFieldValidator('expiryMonth', 'min') || formFieldValidator('expiryMonth', 'max')">{{ 'CreditCard.FormErrors.ExpirationMonthInvalid' | translate}}</span>
      <span class="form-errors"
      *ngIf="formFieldValidator('expiryYear', 'required')">{{ 'CreditCard.FormErrors.ExpirationYearRequired' | translate}}</span>
      <span class="form-errors"
      *ngIf="formFieldValidator('expiryYear', 'min') || formFieldValidator('expiryYear', 'max')">{{ 'CreditCard.FormErrors.ExpirationYearInvalid' | translate}}</span>
    </ion-item> -->
  </ion-col>
  <ion-col style="padding: 0;">
    <div class="custom-form-group">
      <input autocomplete="new-password" formControlName="cvc" [pattern]="'[0-9]*'" (ionChange)="submit()" id="cvc" class="form-control" type="password"  placeholder="" required>
      <label for="cvc">{{ 'CreditCard.Cvn' | translate }}
        @if (formErrors.has('cvc')) {
          <span style="padding-bottom: 2px;" color="danger"><br />{{formErrors.get('cvc')}}</span>
        }</label>
        @if (formFieldValidator('cvc', 'required')) {
          <span style="padding-bottom: 2px;" class="form-errors">{{ 'CreditCard.FormErrors.CvcRequired' | translate}}</span>
        }
      </div>
      <!-- <ion-item class="box">
      <ion-label position="floating" style="margin-bottom: 16px;">
        {{ 'CreditCard.Cvn' | translate }}
        <span *ngIf="formErrors.has('cvc')" color="danger"><br />{{formErrors.get('cvc')}}</span>
      </ion-label>
      <div>
        <ion-input type="password" [pattern]="'[0-9]*'" formControlName="cvc" (ionChange)="submit()"></ion-input>
      </div>
      <span class="form-errors" *ngIf="formFieldValidator('cvc', 'required')">{{ 'CreditCard.FormErrors.CvcRequired' | translate}}</span>
    </ion-item> -->
  </ion-col>
</ion-row>
</ion-grid>
</ion-list>
</form>